<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('users.report') }}</h1>
    </div>
    <div class="details-component__content content">
      <form class="form fixed-form">
        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-150">
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label
                for="decimal-separator"
                class="form__label"
              >{{ $t('report.decimal_separator') }}</label>
            </td>
            <td class="details-table__col">
              <el-select
                v-model="decimalSeparator"
                name="decimal-separator"
                clearable
                placeholder=""
                @change="resetColumnSeparator()"
              >
                <el-option
                  v-for="separator in decimalSeparators"
                  :key="separator.value"
                  :label="separator.label"
                  :value="separator.value"
                />
              </el-select>
            </td>
          </tr>
          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label
                for="column-separator"
                class="form__label"
              >{{ $t('report.column_separator') }}</label>
            </td>
            <td class="details-table__col">
              <el-select
                v-model="columnSeparator"
                name="decimal-separator"
                clearable
                placeholder=""
                @change="updateLocalStorage()"
              >
                <el-option
                  v-for="separator in columnSeparators"
                  :key="separator.value"
                  :label="separator.label"
                  :value="separator.value"
                />
              </el-select>
            </td>
          </tr>
        </table>
        <div class="form__buttons buttonset">
          <router-link
            :to="{ name: 'users' }"
            class="buttonset__button btn btn--secondary"
          >
            {{ $t('common.discard') }}
          </router-link>
          <button
            type="submit"
            class="buttonset__button btn btn--main"
            @click.prevent.stop="onSubmit()"
          >
            {{ $t('report.generate') }}
          </button>
          <a
            v-if="downloadLink && !downloadLink.ie"
            class="buttonset__button btn btn--main"
            :href="downloadLink.href"
            :download="downloadLink.download"
            @click="removeDownloadLink()"
          >
            {{ downloadLink.name }}
          </a>
          <a
            v-if="downloadLink && downloadLink.ie"
            class="buttonset__button btn btn--main"
            :href="downloadLink.href"
            @click.prevent="downloadLink.ie()"
          >
            {{ downloadLink.name }}
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import json2csv from 'json2csv';

export default {
  components: {
  },
  props: ['tenant'],
  data() {
    return {
      form: {},
      decimalSeparator: '.',
      columnSeparator: ',',
      decimalSeparators: [
        {
          value: '.',
          label: '.',
        },
        {
          value: ',',
          label: ',',
        },
      ],
      columnSeparators: [
        {
          value: ',',
          label: ',',
        },
        {
          value: ';',
          label: ';',
        },
        {
          value: '\t',
          label: 'tab',
        },
      ],
      downloadLink: null,
      reportFieldNames: [
        'Permit ID',
        'Parking Card Number',
        'Parking Spot',
        'Vehicle Reg',
        'Permit User',
        'Permit User Email',
        'Permit Created',
        'Permit Deleted',
        'Tenant Name',
        'Product ID',
        'Product Name',
        'Product Total',
        'Product Issued',
      ],
      reportFields: [
        'permitId',
        'permitParkingCard',
        'permitParkingSpot',
        'vehicleReg',
        'user',
        'email',
        'permitCreatedAt',
        'permitDeletedAt',
        'partnerName',
        'productId',
        'productName',
        'productTotal',
        'productIssued',
      ],
      totalFields: [],
    };
  },
  created() {
    if (localStorage.getItem('report-generator')) {
      const reportGeneratorParams = JSON.parse(localStorage.getItem('report-generator'));
      this.decimalSeparator = reportGeneratorParams.decimalSeparator;
      this.columnSeparator = reportGeneratorParams.columnSeparator;
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            return;
          }
          this.$store.dispatch('users/user/fetchReport', { user: this.user })
            .then((response) => {
              response.data.items.map((item) => {
                if (item.permitCreatedAt) {
                  item.permitCreatedAt = moment(item.permitCreatedAt).format('DD.MM.YYYY');
                }
                if (item.permitDeletedAt) {
                  item.permitDeletedAt = moment(item.permitDeletedAt).format('DD.MM.YYYY');
                }
                return item;
              });
              this.generateReport(response.data.items, response.data.totals);
            });
        })
        .catch(() => {
        });
    },
    generateReport(items, totals) {
      const csvFieldNames = this.reportFieldNames;
      const csvFields = this.reportFields;
      const report = json2csv({
        data: items,
        fields: csvFields,
        fieldNames: csvFieldNames,
        del: this.columnSeparator,
      });
      const total = json2csv({
        data: totals,
        fields: this.totalFields,
        hasCSVColumnTitle: false,
        del: this.columnSeparator,
      });
      const all = `${report}\n${total}`;
      this.generateExcelLink(all);
    },
    generateExcelLink(csv) {
      const blob = new Blob([csv], { type: 'text/csv' });
      const date = moment().format('YYYY-MM-DD-HHmmss');
      const fileName = `users_${date}`;
      this.downloadLink = {};
      this.downloadLink.name = this.$t('report.download');

      if (window.navigator.msSaveOrOpenBlob) {
        this.downloadLink.href = `${fileName}.csv`;
        this.downloadLink.ie = () => {
          window.navigator.msSaveOrOpenBlob(blob, this.downloadLink.download);
          this.removeDownloadLink();
        };
      } else {
        this.downloadLink.href = window.URL.createObjectURL(blob);
        this.downloadLink.download = `${fileName}.csv`;
      }
    },
    base64(s) {
      return window.btoa(unescape(encodeURIComponent(s)));
    },
    removeDownloadLink() {
      this.downloadLink = null;
      this.form = {};
    },
    resetColumnSeparator() {
      if (!this.storedColumnSeparators) {
        this.storedColumnSeparators = this.columnSeparators;
      }
      this.columnSeparators = [];
      this.storedColumnSeparators.forEach((item) => {
        if (item.value !== this.decimalSeparator) {
          this.columnSeparators.push(item);
        }
      });
      this.columnSeparator = this.columnSeparators[0].value;
      this.updateLocalStorage();
    },
    updateLocalStorage() {
      localStorage.setItem('report-generator', JSON.stringify(
        {
          decimalSeparator: this.decimalSeparator,
          columnSeparator: this.columnSeparator,
        },
      ));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/ExportUsersForm.vue